import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Pagin from 'src/components/common/Pagin';
import { getDetailPagin } from 'src/common/helper';

const ReservationTab = (props: any) => {
  return (
    <>
      <TableContainer component={Paper}>
        <Table
          sx={{
            minWidth: 650,
            '& .MuiTableCell-root.MuiTableCell-head': {
              borderBottom: '1px solid #F3F3F3',
              fontWeight: 700,
              p: '6px 16px',
              fontSize: '14px',
              minWidth: '100px',
            },
            '& .MuiTableCell-root.MuiTableCell-body': {
              color: 'primary.dark',
              fontSize: '14px',
              py: '10px',
            },
          }}
          aria-label='simple table'
        >
          <TableHead>
            <TableRow>
              <TableCell>予約ID</TableCell>
              <TableCell>患者ID</TableCell>
              <TableCell>患者名</TableCell>
              <TableCell>医師</TableCell>
              <TableCell>予約日</TableCell>
              <TableCell>開始時間</TableCell>
              <TableCell>終了時間</TableCell>
              <TableCell>来院時間</TableCell>
              <TableCell>予約タイプ</TableCell>
              <TableCell>希望施術</TableCell>
              <TableCell>ステータス</TableCell>
              <TableCell>担当者</TableCell>
              <TableCell>見積ID</TableCell>
              <TableCell>備考</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.map((row: any, index: number) => (
              <TableRow
                key={index}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.patientno}</TableCell>
                <TableCell>{row.fullname}</TableCell>
                <TableCell>{row.doctor}</TableCell>
                <TableCell>{row.thedate}</TableCell>
                <TableCell>{row.starttime}</TableCell>
                <TableCell>{row.finishtime}</TableCell>
                <TableCell>{row.visittime}</TableCell>
                <TableCell>{row.reservetype}</TableCell>
                <TableCell>{row.visitnote}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>{row.person}</TableCell>
                <TableCell>{row.quoteid}</TableCell>
                <TableCell>{row.note}</TableCell>
              </TableRow>
            ))}
            {props.data.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={14}
                  sx={{ textAlign: 'center', verticalAlign: 'center' }}
                >
                  データがありません
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {props.data.length > 0 && props.pagination && (
        <Box display={'flex'} justifyContent={'right'} mt={'10px'}>
          <Typography
            component='label'
            sx={{
              color: '#AAB2BD',
              fontWeight: '400',
              fontSize: '10px',
              lineHeight: '12px',
            }}
          >
            {getDetailPagin(props.pagination)}
          </Typography>
        </Box>
      )}
      {props.data.length > 0 && props.pagination && props.pagination.page && (
        <Pagin
          handlePageChange={props.handlePageChange}
          pagination={props.pagination}
        />
      )}
    </>
  );
};

export default ReservationTab;
